import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  input: {
    display: 'flex',
    padding: 0,
    height: '23px'
  }
}))

const inputComponent = ({ inputRef, ...props }) => {
  return <div ref={inputRef} {...props} />
}

inputComponent.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

const Control = props => {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: { TextFieldProps }
  } = props

  const classes = useStyles()

  return (
    <TextField
      fullWidth
      // variant='filled'
      InputProps={{
        inputComponent,
        inputProps: {
          className: classes.input,
          ref: innerRef,
          children,
          ...innerProps
        }
      }}
      {...TextFieldProps}
    />
  )
}

Control.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  selectProps: PropTypes.object.isRequired
}

export default Control
